import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination } from 'src/app/common/models/pagination';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { CompanyDepartmentMember } from 'src/app/lem/models/departments/member/member';

@Component({
  selector: 'app-members-list',
  templateUrl: './members-list.component.html',
  styleUrls: ['./members-list.component.css']
})
export class MembersListComponent implements OnInit {

  @Input() resetCurrentPage: boolean;
  @Input() members : PaginatedResponse<CompanyDepartmentMember>;
  @Output() edit = new EventEmitter<CompanyDepartmentMember>();
  @Output() delete = new EventEmitter<CompanyDepartmentMember>();
  @Output() finish = new EventEmitter<CompanyDepartmentMember>();
  @Output() transfer = new EventEmitter<CompanyDepartmentMember>();
  @Input() pagable:Pagable;
  @Output() refreshEvent: EventEmitter<Pagination> = new EventEmitter<Pagination>();

  constructor() { }



  ngOnInit() {

  }

  onEdit(member : CompanyDepartmentMember) {
    this.edit.emit(member);
  }
  onDelete(member : CompanyDepartmentMember) {
    this.delete.emit(member);
  }
  onFinish(member : CompanyDepartmentMember) {
    this.finish.emit(member);
  }
  onTransfer(member : CompanyDepartmentMember) {
    this.transfer.emit(member);
  }


}
